import { useMutation } from "@tanstack/react-query"
import { api } from "../lib/api"

export default function useOtp() {
	const useSendOtp = (type: "EMAIL" | "MOBILE") => {
		return useMutation({
			mutationFn: async ({
				email = "",
				countryCode = "",
				phoneNumber = "",
				universityId,
				batchId,
				applicationId,
			}: {
				email?: string
				countryCode?: string
				phoneNumber?: string
				universityId: string
				batchId: string
				applicationId: string
			}) => {
				let url = `universities/${universityId}/batches/${batchId}/applications/${applicationId}/verify-otp?`
				if (type == "EMAIL") {
					url += `&email=${email}`
				} else {
					url += `&country_code=${countryCode}&mobile=${phoneNumber}`
				}

				const { data } = await api.get(url)

				return data
			},
			mutationKey: ["send-otp", type],
		})
	}

	const useVerifyOtp = (applicationId: string) => {
		return useMutation({
			mutationFn: async (payload: {
				type: "EMAIL" | "MOBILE"
				email?: string
				countryCode?: string
				phoneNumber?: string
				otp: string
				field_id: string
				universityId: string
				batchId: string
			}) => {
				const { data } = await api.post<{ is_valid: boolean }>(
					`universities/${payload.universityId}/batches/${payload.batchId}/applications/${applicationId}/verify-otp`,
					payload,
				)
				return data
			},
		})
	}

	return {
		useSendOtp,
		useVerifyOtp,
	}
}
